import React from 'react'
import { Typography, Box } from '@mui/material'

interface ModernLabelProps {
  label: string
  children: React.ReactNode
}

export const ModernLabel: React.FC<ModernLabelProps> = ({
  label,
  children
}) => {
  return (
    <Box display='flex' flexDirection='column' mb={2}>
      <Typography variant='subtitle2' color='textSecondary'>
        {label}
      </Typography>
      {children}
    </Box>
  )
}
